import { jadeVi } from "../../i18n/tilecastle.vi.ts";
import { Art } from "../components/common.tsx";
import "../../styles/tilecastle.css";

/** Tiles left on the floor and the satchel's gold line, under the level title. */
export function JadeHudLine({ left, goldLine }: { left: number; goldLine: number }) {
  return (
    <span className="puzzle-hud__moves" data-testid="jade-left">
      <Art id="jade.tile" className="ico-inline" />
      {jadeVi.left(left)}
      <span className="puzzle-hud__target" aria-label={jadeVi.goldLine(goldLine)}>
        <Art id="jade.pin" className="ico-inline" />
        {goldLine}
      </span>
    </span>
  );
}

export function JadeStuck() {
  return (
    <p className="jade-stuck" role="status" data-testid="jade-stuck">
      {jadeVi.stuck}
    </p>
  );
}
